export default "__VITE_ASSET__DVZ7TKyy__"